function UnitManagerOverview() {
/// <summary>
    /// This object provides all common js functions for the Widget.Signal.SignalAnalog.Overview.vb and Widget.Signal.SignalDigital.Overview.vb. <br/>
    /// Specific analog or digital functions get overwriten by the derived js-classes.  
    /// Author: AFU<br />
    /// Date: 14.2.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 20.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -  exctracted from serverside code                                 *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.menuFilter = "";
    this.detailsOpen = false;
    this.frameWidth = 0;
    this.frameHeight = 0;
    this.detailsListWidth = 400;
}

UnitManagerOverview.prototype = new vcTemplate();

UnitManagerOverview.prototype.init = function () {
    /// <summary>
    /// This function sets specific widths, heights and inits the specific event handlers.<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        //if we just want to edit 1 single signal we need no menu at all
        if (me.singleEdit) {
            me.visual.find(".vc-tree-menu").width(0);
            me.visual.find(".menu, #error-1, #btnSort, .vc-list-header").hide();
           
        } 
        me.frameHeight = me.height - 10;
        me.visual.find('.signalOverviewDetail').height(me.frameHeight);

        //this is used for dialogs or popups where not the complete browser width is used
        //so, we have to fix the single column style manually
      
        if (me.width <= 1300) {
            me.visual.find(".vc-list").addClass("single-column");
        } 

        //if we want to use the left tree menu we have to fix the with of the signal list and move it to the right
        if (me.visual.find(".vc-tree-menu").width() > 0) {
            me.visual.find("#divFrame, .signalOverviewList").width(parseInt(me.visual.find("#divFrame").width(), 10) - parseInt(me.visual.find(".vc-tree-menu").width(), 10) - 40);
            //set the width of the details without the left menu 
          
        } else {
            me.visual.find(".vc-tree-menu").hide();
            me.visual.find(".signalOverviewList").width(parseInt(me.visual.find("#divFrame").width(), 10) - 0);
        }
        if (me.singleEdit) {
            me.frameWidth = me.width;
        } else {
            me.frameWidth = me.visual.find("#divFrame").width();
        }
       
      
        //we fix the width and height of the overview list and the detail forms
        me.visual.find('.signalOverviewDetail').width(me.visual.width() - me.detailsListWidth - 30);
        me.visual.find('.signalOverviewList').height(me.frameHeight - parseInt(me.visual.find("#divHeader").height(), 10) - parseInt(me.visual.find(".menu").height(), 10) + 30);
        me.visual.find('.menu').width(me.frameWidth - 320); //remove the 2 buttons on the right from the max width
        //init the filter items



        me.visual.find(".vc-filter").vcFilter({ callback: function () {  me.filterSignalList(); } });
        //init the basic and common event handler
        me.initClickHandler();
        //int the specific handlers for analog signals 
        me.initSpecificRefreshHandler();
        return true;
    } catch (ex) { me.writeError('init', ex); return false }
}


UnitManagerOverview.prototype.initClickHandler = function () {
    /// <summary>
    /// This function initializes different click handlers and calls the initSpecificClickHandler() function for further click handlers for analog and digital signals <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        //init new button
        me.visual.find('#error-1').button();

        //init the 'show error only' checkbox 
        me.visual.find(".vc-list").on("click", '#chbSelectError', function () { me.filterSignalList(); });

        //hover event for errors and warnings - shows the error info popup
        me.visual.find(".vc-list").on({
            mouseenter: function () {
                var classList = $(this).attr('class').split(/\s+/);
                me.visual.find('#divRulePopup').show(0);
                me.visual.find('#divRulePopup .ruleDescr,#divRulePopup .rule').hide(0);
                $.each(classList, function (index, item) {
                    if (item.length > 0) {me.visual.find('#divRulePopup .' + item).show(0);}
                });
            },
            mouseleave: function () { me.visual.find('#divRulePopup').hide(0); }
        }, ".err,.warn");

        //init the sorting button
        me.initBtnSorting();
        //int the different click handlers for analog and digital signals 
        me.initSpecificClickHandler();
        
        //set focus to filter input field
        me.visual.find('#txtFilter').focus();
        return true;
    } catch (ex) { me.writeError('initClickHandler', ex); return false }
};

UnitManagerOverview.prototype.initMenu = function () {
    /// <summary>
    /// Not needed here
    /// </summary>
}

UnitManagerOverview.prototype.refresh = function (bShowDetails) {
    /// <summary>
    /// This function ... <br/>
    /// </summary>
    var me = this;
    var currentBsaid = null;
    try {
        if (me.error) {
            return false;
        }
        //hide the tag column - we have to expand the new tags first
        me.visual.find(".signalOverviewList .tdtags").hide();

        if (me.detailsOpen) {
            currentBsaid = me.visual.find(".vc-list .vc-list-item.selected").attr('id');
        }

        //reset the current id
        if (bShowDetails === false) { me.currentID = -1;  }
        //get the new signal list
        window.VisualCoreService.getVisualContent(me.vcvid, me.vcgid, getCurrentTimestamp(), me.height,me.visual.find('#divFrame').width(),JSON.stringify({ 'blhid':me.blhid, 'bsaid': me.bsaid}),'',me.deviceType,
            function (result) {
                if (result === '') {  alert(me.resources.err_loadData); return false; }

                    //NOTE - FIX THAT
                    // form" & VCGID & "=null; 
        
                me.visual.find('.signalOverviewList').html(result);
                if (me.detailsOpen) {
                    me.visual.find(".vc-list #" + currentBsaid).addClass("selected");
                }
                //int the specific handlers for analog signals 
                me.initSpecificRefreshHandler();

                //init the filter
                me.filterSignalList();

                //send a message that the signal state has been updated 
                 if (bShowDetails) {
                   _VCMQ.produce(me.visual, me.vcgid, 'UPDATE_SIGNAL_STATE', '');
                 }
                 return true;
              });
          return true;
    } catch (ex) {me.writeError('refresh', ex); return false;}
}; 



UnitManagerOverview.prototype.filterSignalList = function () {
    /// <summary>
    /// This function does the list filtering. <br/>
    /// It receives an optional menu filter string from the vc-tree-menu or a list of filter tags from the vc-filter item.<br/>
    /// It iterates all list entries and increases a counter for each found filter item and signal. Then, it hides all entries where the counter is lower than the number of filter items. <br/>
    /// </summary>
    var me = this;
   
    try {
        if (me.error) {
            return false;
        }

        //hide and reset everything
        me.visual.find('.vc-list-table li.vc-list-item').removeClass('icon-color-error tag-found menu-filter-found').hide();
 
        //first we filter all signals with the tag we got from the vc-tree-menu
        if (me.menuFilter.length > 0) {
            if (me.menuFilter !== 'no_assigned_tags') {
                me.visual.find('.vc-list-table .vc-list-item').filter(function() {
                    var item = $(this);

                    if ($(this).find(".vc-tags-item-system").html() === me.menuFilter) {
                        item.addClass("menu-filter-found");
                        return true;
                    }
                    var tags;
                    $(this).find(".vc-tags-item").each(function () {
                        tags = $(this).attr("title").split(" / ");
                        for (var i = 0; i <= tags.length - 1; i++) {
                            if (tags[i] === me.menuFilter) {
                                item.addClass("menu-filter-found");
                                return true;
                            }
                        }

                        // ReSharper disable once NotAllPathsReturnValue
                    });

                    return false;
                });

            } else {
                me.visual.find('.vc-list-table .vc-list-item').filter(function () { return $(this).find(".vc-tags-item").not(".vc-tags-item-system").length === 0 }).addClass("menu-filter-found");
            }
        } else {   
            me.visual.find(".vc-list-table .vc-list-item").addClass("menu-filter-found");
        }

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "tag-found");

        //handle the 'show errors only' checkbox 
        if (me.visual.find('#chbSelectError').is(':checked')) {
            me.visual.find('.vc-list-table .vc-list-item').filter(function () { return $(this).find('.err').length === 0 }).removeClass("tag-found");
        }
        //show only valid entries
        me.visual.find(".vc-list-table .vc-list-item.tag-found.menu-filter-found").show();
        return true;
    } catch (ex) { me.writeError('filterSignalList', ex); return false; }
}; 




UnitManagerOverview.prototype.toggleDetails = function (madeSelection) {
    /// <summary>
    /// This function handles the detail click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        //if we clicked on a signal - we made a selection (madeSelection=true)
        if (madeSelection) {
            //if we are in the overview list
            if (me.detailsOpen ===false && (me.visual.find('#divHeader').is(":visible") || me.singleEdit === true)) {
                //hide the main menu
                //add the css class for the edit mode
                me.visual.find("#divFrame").width(me.visual.width());
                me.visual.find('.vc-tree-menu,  #divHeader, .menu').hide();

                if (me.singleEdit === false) {
                    me.visual.find('.signalOverviewList').width(me.detailsListWidth);
                    me.visual.find('.signalOverviewList').height(me.frameHeight - 5);
                    me.visual.find('.signalOverviewList').removeClass('editMode').addClass('editMode');
                } else {
                    me.visual.find('.signalOverviewList').hide();
                    me.visual.find('.signalOverviewDetail').width(me.frameWidth);
                }

                me.detailsOpen = true;
            }
        } else {
           // if we use the vc-tree-menu - let's show it again
            if (me.visual.find('.vc-tree-menu').width() > 0) { me.visual.find('.vc-tree-menu').show(); }
            //add the css class for the edit mode
            me.visual.find(".vc-list-item").removeClass('selected');
            me.visual.find('.signalOverviewList').show();

            if (me.singleEdit === false) {
                me.visual.find('#divHeader, .menu').show();
                me.visual.find('.signalOverviewList').height(me.frameHeight - parseInt(me.visual.find("#divHeader").height(), 10) - parseInt(me.visual.find(".menu").height(), 10) + 30);
            }

            me.visual.find('.signalOverviewList').width(me.frameWidth).removeClass('editMode');
            me.visual.find('.signalOverviewDetail').hide();
            me.visual.find("#divFrame").width(me.frameWidth);
           
            me.detailsOpen = false;
        }
        return true;
    } catch (ex) { me.writeError('toggleDetails', ex); return false }
}

UnitManagerOverview.prototype.initBtnSorting = function () {
    /// <summary>
    /// This function inits the sorting button <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        //handles the sorting button and opens the sorting list.
        me.visual.find('#btnSort').button().unbind('click').click(function() { 
            me.visual.find('#divFrame, .vc-tree-menu').hide();
            me.visual.find('#divSort').show().html(me.vcC.getLoadingIcon());
            window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), parseInt(me.visual.find('#divSort').height(), 10), parseInt(me.visual.find('#divSort').width(), 10), '', JSON.stringify({ "pid": me.pid, "blid": me.blid }), me.deviceType, me.langid, JSON.stringify({ 'type': 2 }),
                function (result) {
                    if (result === '') {   alert(me.resources.err_loadData); return false; }
                me.visual.find('#divSort').html(result);
                me.initSortList();
                me.initBtnBackSort();
                me.initBtnSaveSort();
                me.initHorizontalSorting();
                return true; 
                });
        }); 
    } catch (ex) { me.writeError('initBtnSorting', ex); return false }
    return true;
}; 

//inits the signal list and makes it sortable
UnitManagerOverview.prototype.initSortList = function () {
    /// <summary>
    /// This function inits the sortable sorting list <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }


        me.visual.find('#lstSort').on('click',
            'li',
            function (e) {
                
                if (e.ctrlKey || e.metaKey) {
                    
                    $(this).toggleClass("selected");
                } else {
                    $(this).addClass("selected").siblings().removeClass('selected');
                }
            });

        me.visual.find('#lstSort').sortable({connectWith: '.connectedSortable',placeholder: 'formSortPlaceholder',forcePlaceholderSize: true,tolerance:'pointer',scrollSensitivity:30, 
            update: function (event, ui) {
                //avoid ids which have been moved out of the list to disapear
                if ($(ui.item).parent().attr('id') !== 'lstSort') {return false};
                me.visual.find('#btnSaveSort').button('enable'); //enable save button
                $(ui.item).find('.formSortLine').addClass('formSortEntryDirty');
                return true;
            },
            helper: function (e, item) {
                //Basically, if you grab an unhighlighted item to drag, it will deselect (unhighlight) everything else
                if (!item.hasClass('selected')) {
                    item.addClass('selected').siblings().removeClass('selected');
                }

                //////////////////////////////////////////////////////////////////////
                //HERE'S HOW TO PASS THE SELECTED ITEMS TO THE `stop()` FUNCTION:

                //Clone the selected items into an array
                var elements = item.parent().children('.selected').clone();

                //Add a property to `item` called 'multidrag` that contains the 
                //  selected items, then remove the selected items from the source list
                item.data('multidrag', elements).siblings('.selected').remove();

                //Now the selected items exist in memory, attached to the `item`,
                //  so we can access them later when we get to the `stop()` callback

                //Create the helper
                var helper = $('<li/>');
                return helper.append(elements);
            },
            stop: function (e, ui) {
                //Now we access those items that we stored in `item`s data!
                var elements = ui.item.data('multidrag');

                //`elements` now contains the originally selected items from the source list (the dragged items)!!

                //Finally I insert the selected items after the `item`, then remove the `item`, since 
                //  item is a duplicate of one of the selected items.
                ui.item.after(elements).remove();
                me.visual.find('#btnSaveSort').button('enable'); //enable save button
                $(ui.item).find('.formSortLine').addClass('formSortEntryDirty');
            }
    
        }).disableSelection();
    } catch (ex) { me.writeError('initSortList', ex); return false }
    return true;
};

 //inits the back button
UnitManagerOverview.prototype.initBtnBackSort = function () {
    /// <summary>
    /// This function the back button for the sorting list <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find('#btnBackSort').button().unbind('click').click(function() {
            me.visual.find('#divFrame, .vc-tree-menu').show();
            me.visual.find('#divSort').hide();
            me.refresh(false);
        });
    } catch (ex) { me.writeError('initBtnBackSort', ex); return false }
    return true;
};  


//inits the horizontal checkbox
UnitManagerOverview.prototype.initHorizontalSorting = function () {
    /// <summary>
    /// This function changes the vertical sorting list to a horizontal one <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find('#chbHorizontal').off('click').on('click', function() { 
        if ($(this).prop('checked')) {
        me.visual.find('#lstSort').addClass('horizontal'); 
        } else {
        me.visual.find('#lstSort').removeClass('horizontal'); 
        }
        });
    } catch (ex) { me.writeError('initHorizontalSorting', ex); return false }
    return true;
};  

 //inits the save button
UnitManagerOverview.prototype.initBtnSaveSort = function () {
    /// <summary>
    /// This function inits the save button for the sorting list <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find('#btnSaveSort').button().button('disable').unbind('click').click(function() { 
            var ids = [];
            me.visual.find('#lstSort li.formSortEntry').each(function () {
            ids.push($(this).attr('id'));
            }); 
            window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', JSON.stringify({ "pid": me.pid, "blid": me.blid }), me.deviceType, me.langid, JSON.stringify({ 'type': 1, 'signallist': ids }),
                function (result) {
                if (result == null) {return false; }
                if (result === false) { alert(me.resources.err_saveData); return false; }
                me.visual.find('#divFrame, .vc-tree-menu').show();
                me.visual.find('#divSort').hide();
                me.refresh(false);
                return false; 
            }); 
        }); 
    } catch (ex) { me.writeError('initBtnSaveSort', ex); return false }
    return true;
};  



UnitManagerOverview.prototype.doEvent = function (event) {
    /// <summary>
    /// This function handles the VCMQ events.
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }
       
        switch (event.msg) {
            case 'TAGS_REFRESH':
                //received when tags have been changed 
                //let's reload the vc-tree-menu and the signal list
                me.initMenu();
                me.refresh(true);

                break;
            case 'UNITMANAGER_ANALOGOVERVIEW_REFRESH':
                //is sent when the analog signal list in the vcUnit.aspx is already loaded and the button in the main menu has clicked again
                me.refresh(true);
                break;
            case 'BSAID_REFRESH':
                //analog signal settings have been changed
                //is used in the detail view 
                //the signal list get's reloaded after changing the settings of one signal
                me.refresh(true);
                break;
            case 'SIGNAL_DIGITAL_EDIT_CLOSE':
                //digital signal settings have been changed
                //is used in the detail view 
                //the signal list get's reloaded after changing the settings of one signal
                if (event.values.length === 0) {me.toggleDetails(false);}
                me.refresh(event.values.length > 0);
                break;//refresh list when closing SignalDigital.Edit
            case 'SIGNAL_ANALOG_DETAIL_CLOSE':
                //the detail view has bee closed
                me.toggleDetails(false);
                me.refresh(false);
                break; //refresh list when closing SignalAnalog.Detail
            default: break;
        }
        return true;
    } catch (ex) { me.writeError('doEvent', ex); return false; }

};



UnitManagerOverview.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) { me.visual.find('#divFrame, .vc-list-table').hide(); }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};




function UnitManagerAnalogOverview() {
    /// <summary>
    /// This class contains specifi analog functions.
    /// Author: AFU<br />
    /// Date: 14.2.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -  exctracted from serverside-code                                 *<br />
    /// **********************************************************************<br />
    /// </summary>
}

UnitManagerAnalogOverview.prototype = new UnitManagerOverview();



UnitManagerAnalogOverview.prototype.initMenu = function () {
    /// <summary>
    /// This function inits the vc-tree-menu object and sets the callback handlers <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //do nothing if the tree menu div has width=0!!!
        if (me.singleEdit) { return true; }

        if (typeof(me.visual.find(".vc-tree-menu")) === "undefined") { return true; }

        if (me.visual.find(".vc-tree-menu").width() === 0) { return true; }
        
        me.visual.find('.vc-tree-menu').show().html(me.vcC.getLoadingIcon());

        //init list entry click handler
        window.VisualCoreService.getData(me.vcvid, '', getCurrentTimestamp(), 0, 0, '', JSON.stringify({ "pid": me.pid, "blid": me.blid }), me.deviceType, me.langid, JSON.stringify({ 'type': 4 }),
          function (result) {
              if (result == null) { me.writeError('initMenu.vcTreeMenu', me.resources.err_loadData); return false; }
              if (result.rows === null) { me.visual.find('.vc-tree-menu').html("<div class='note'>" + me.resources.noEntriesExist + '</div>'); return false; }
              if (result.rows.length === 0) {
                  me.visual.find('.vc-tree-menu').html("<div class='note'>" + me.resources.noEntriesExist + '</div>').show();
                  return false;
              }
              me.visual.find('.vc-tree-menu').vcTreeMenu({
                  "h": me.height,"showAllAtStart": true,showTickets:false,
                  "data": result,
                  "callback": function (e) {
                      switch (e.type) {
                          case "init": 
                              me.menuFilter = e.value;
                              me.filterSignalList();
                              break;
                          case "update":
                              me.menuFilter = e.value;
                              me.filterSignalList();
                              break;
                          case "error":
                              me.writeError('initMenu.vcTreeMenu', e.value);
                              break;
                          default:
                      }
                  }
              });
              return true;
          });

        return true;
    } catch (ex) {me.writeError('initMenu', ex); return false;}
};


UnitManagerAnalogOverview.prototype.initSpecificRefreshHandler = function () {
    /// <summary>
    /// This function inits specific functions for tags and signal rules <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //show all rules if the toggle button is activated
        if (me.visual.find("#btnToggleRules").hasClass("button-toggle-active")) {me.showAllRules();}
        
        //me.initMenu();


        //expand all hidden raw tags
        $.each(me.visual.find('.selectSignal .tdtags'), function () {
             $(this).html(me.vcC.expandTags($(this).html()));
         });
         me.visual.find(".tdtags").show();
         return true;
    } catch (ex) { me.writeError('initSpecificRefreshHandler', ex); return false; }
}



UnitManagerAnalogOverview.prototype.showAllRules = function () {
    /// <summary>
    /// This function iterates all rules and loads every rule <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //loads rules for each rule signal in list
        $.each(me.visual.find('.signalRule'), function() {
            var tag = $(this);
            var id = $(this).data('id');
            var rid = $(this).data('rid');
            me.showRule(tag, id, rid);
        });
        return true;
    } catch (ex) { me.writeError('showAllRules', ex); return false; }
}

UnitManagerAnalogOverview.prototype.showRule = function (tag, id, rid) {
    /// <summary>
    /// This function loads a signle rule <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        tag.html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', JSON.stringify({ "pid": me.pid, "blid": me.blid }), me.deviceType, me.langid, JSON.stringify({ 'type': 3, 'bsaid': id, 'rid': rid }),
            function (result) {
                if (result === '') { result = me.resources.err_loadData }
                tag.parents(".tdrule").html(result).removeClass("main");
            return false; 
        });
    } catch (ex) { me.writeError('showRule', ex); return false; }
    return true;
}



UnitManagerAnalogOverview.prototype.toggleRuleButton = function (obj) {
    /// <summary>
    /// This function toggles the rule button and loads all rules if the button gets activated <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        if (obj.hasClass("button-toggle-active")) {
            obj.removeClass("button-toggle-active");
        } else {
            obj.addClass("button-toggle-active");
            me.showAllRules();
        }
        return true;
    } catch (ex) { me.writeError('toggleTempButton', ex); return false; }
};


UnitManagerAnalogOverview.prototype.initSpecificClickHandler = function () {
    /// <summary>
    /// This function inits all specific click handlers and dialogs. <br/>
    /// </summary>
    var me = this;
    var bDetailFormOpen = false;
    var bDetailFormDirty = false;
    var errorMsg = '';

    var container;
    try {
        if (me.error) { return false; }

        me.initMenu();
       

        //inits the dialog for the editing of tags and signal addresses
        var dialogEdit = me.visual.find("#divEditContainer").dialog({
            title: '',autoOpen: false,modal: true,width: 1000,height: 810,
            position: { my: 'top+5%', at: 'top', of: window },
            buttons: [{
                    text: me.resources.close,
                    click: function() {
                        dialogEdit.dialog('close');
                        me.refresh(true);
                    }
                }],
            open: function() { me.visual.find("#divEditContainer").show(); },
            dialogClass: 'saveDialog'
        });

        if (me.singleEdit === false ) {
            //adds/removes the edit icon on hovering the tags list/column
            me.visual.find(".vc-list").on("mouseenter", ".tdtags",
                function() { $(this).append("<div class='edit-icon'><i class='fa fa-pencil icon-color-info' ></i></div>"); });
            me.visual.find(".vc-list").on("mouseleave", ".tdtags",
                function() { $(this).children("div.edit-icon").remove(); });

            //adds the click handler for the tag-edit-icon
            me.visual.find(".vc-list").on("click", ".tdtags .edit-icon", function(e) {
                var bsaid = parseInt($(this).parents(".vc-list-item").data("id"), 10);
                container = me.getRandomIDContainerObj("divEditContainer", true);
                dialogEdit.html(container.obj);
               
                me.vcVisual.addVisualBaseByName("divEditContainer", 'VISUAL_TAGS_ASSIGNMENT_TAGS2SIGNAL', container.random, getCurrentTimestamp(), 710, 980, JSON.stringify({ "assid": bsaid }), "", me.deviceType);
                dialogEdit.dialog('open');
                e.stopPropagation();
            });

        }
        //ints the click handler for the signal addresses
        me.visual.find(".vc-list").on("click", ".signal-address", function(e) {
            var bsaid = parseInt($(this).parents(".vc-list-item").data("id"), 10);
            container = me.getRandomIDContainerObj("divEditContainer", true);
            dialogEdit.html(container.obj);
            me.vcVisual.addVisualBaseByName("divEditContainer", 'VISUAL_FORM_SIGNAL_ANALOG_ADDRESS', container.random, getCurrentTimestamp(), 660,
                950, JSON.stringify({ "bsaid": bsaid }), "", me.deviceType);
            dialogEdit.dialog('open');
            e.stopPropagation();
        });


        //click handler for the 'show all rules' toggle button
        //if active - all rules get loaded after me.refresh()
        me.visual.find("#btnToggleRules").on("click", function() { me.toggleRuleButton($(this)); }).button();


        //click handler for a single rule entry
        me.visual.find(".vc-list").on("click", '.signalRule', function(e) {
            var id = parseInt($(this).data("id"), 10);
            var rid = parseInt($(this).data("rid"), 10);
           
            me.showRule($(this), id, rid);

            e.stopPropagation();
        });
        
        //click handler for a single list entry
        me.visual.find(".vc-list").on("click", '.vc-list-item,#error-1', function() {
            //go to the detail view
            me.toggleDetails(true);

            var bsaid = $(this).attr('id');
            bsaid = bsaid.replace('error', '');

            me.visual.find(".vc-list-item").removeClass('selected');
          
            //find out if the detail view is already on
            bDetailFormOpen = me.visual.find('.signalOverviewDetail').is(':visible');
           
            if (bDetailFormOpen) {

               
                $(this).addClass('selected');
                errorMsg = $('#divFormDetail' + me.vcgid + 'STATE').data('message');
                bDetailFormDirty = $('#divFormDetail' + me.vcgid + 'STATE').data('dirty');
            }

            me.visual.find('.signalOverviewDetail').show().html(me.vcC.getLoadingIcon());

            me.vcVisual.addVisualContentByName('divSignalOverview', 'VISUAL_SIGNAL_ANALOG_DETAIL', 'Detail' + me.vcgid,
                getCurrentTimestamp(), parseInt(me.visual.find('.signalOverviewDetail').height(), 10), parseInt(me.visual.find('.signalOverviewDetail').width(), 10), JSON.stringify({ 'blhid': me.blhid, 'bsaid': bsaid }), '', me.deviceType);

            if (parseInt(bsaid, 10) > -1) {
                //store the current signal id
                me.currentID = bsaid;

                //mark the selected signal 
                $(this).addClass('selected');

                //if the edit form is visible we have a look if we find an error message in the current detail form 
                if (bDetailFormOpen) {
                    if (errorMsg.length > 0) {
                        if (confirm(errorMsg, 'Validation') === false) {
                            return true;
                        }
                    }

                    if (bDetailFormDirty) { me.refresh(true);}
                }
            }

            return true;
        });
    } catch (ex) {me.writeError('initSpecificClickHandler', ex); return false;}
    return true;
};


function UnitManagerDigitalOverview() {
    /// <summary>
    /// This class contains specific digital functions.
    /// Author: AFU<br />
    /// Date: 14.2.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -  exctracted from serverside-code                                 *<br />
    /// **********************************************************************<br />
    /// </summary>
}

UnitManagerDigitalOverview.prototype = new UnitManagerOverview();

UnitManagerDigitalOverview.prototype.initSpecificClickHandler = function () {
    /// <summary>
    /// This function inits all specific click handlers and dialogs. <br/>
    /// </summary>
      var me = this;
    try {
        if (me.error) { return false; }
    //click handler for a single list entry
      me.visual.find(".vc-list" ).on("click", '.selectSignal,#error-1', function() { 

          me.toggleDetails(true);

          me.visual.find(".vc-list-item").removeClass('selected');

          var bsdid = $(this).attr('id');
          bsdid = bsdid.replace('error', ''); 

          if (parseInt(bsdid,10)>-1) {
            //store the current signal id
            me.currentID = bsdid; 
      
            //mark the selected signal 
            $(this).addClass('selected');
            //if the edit form is visible
            if (me.visual.find('.signalOverviewDetail').is(':visible')) {
               me.refresh(true);
            }
         }

         me.visual.find('.signalOverviewDetail').show().html(me.vcC.getLoadingIcon());
         me.vcVisual.addVisualContentByName('divSignalOverview', 'VISUAL_FORM_SIGNAL_DIGITAL', 'Detail' + me.vcgid, getCurrentTimestamp(), parseInt(me.visual.find('.signalOverviewDetail').height(),10)-30, parseInt(me.visual.find('.signalOverviewDetail').width(),10)-60,JSON.stringify({ 'blhid':me.blhid,  'bsdid': bsdid}), '', me.deviceType);
   });
    } catch (ex) { me.writeError('initSpecificClickHandler', ex); return "" }
    return true;
};

UnitManagerDigitalOverview.prototype.initSpecificRefreshHandler = function () {
    /// <summary>
    /// Not needed here
    /// </summary>
}

UnitManagerDigitalOverview.prototype.initMenu = function () {
    /// <summary>
    /// Not needed here
    /// </summary>
}